import { authHeader } from "_helpers";
import { SERVER_URL } from "config";
import axios from "axios";

function getOrgInboxMessages(params) {
  const endpoint = `${SERVER_URL}/api/v2/my-organization/messages/inbox`;
  return axios.get(endpoint, {
    params: params,
    headers: authHeader(),
  });
}

function getParentPost(messageId) {
  const endpoint = `${SERVER_URL}/api/messages/${messageId}/parentPost`;
  return axios.get(endpoint, {
    headers: authHeader(),
  });
}

function lockMessage(messageId) {
  const endpoint = `${SERVER_URL}/api/v2/message-queue/${messageId}/lock`;
  return axios.put(endpoint, {}, {
    headers: authHeader(),
  });
}

function regenerateReply(messageId) {
  const endpoint = `${SERVER_URL}/api/messages/${messageId}/generatedReply`;
  return axios.post(endpoint, {}, {
    headers: authHeader(),
  });
}

function unlockMessage(messageId) {
  const endpoint = `${SERVER_URL}/api/v2/message-queue/${messageId}/lock`;
  return fetch(endpoint, {
    method: "DELETE",
    headers: authHeader(),
    keepalive: true,
  });
}

export const inboxService = {
  getOrgInboxMessages,
  getParentPost,
  lockMessage,
  unlockMessage,
  regenerateReply,
};
